<template>
  <v-card class="aru-wysiwyg-editor-container elevation-5">
    <v-card hover class="elevation-1">
      <editor-menu-bar :editor="editor" v-slot="{ commands, isActive, focused }">
        <div class="aru-wysiwyg-menubar menubar">
          <v-btn
            small
            flat
            class="menubar__button"
            :class="{ 'v-btn--active': isActive.bold() }"
            @click="commands.bold"
          >
            <v-icon>mdi-format-bold</v-icon>
          </v-btn>

          <v-btn
            small
            flat
            class="menubar__button"
            :class="{ 'v-btn--active': isActive.italic() }"
            @click="commands.italic"
          >
            <v-icon>mdi-format-italic</v-icon>
          </v-btn>

          <v-btn
            small
            flat
            class="menubar__button"
            :class="{ 'v-btn--active': isActive.strike() }"
            @click="commands.strike"
          >
            <v-icon>mdi-format-strikethrough</v-icon>
          </v-btn>

          <v-btn
            small
            flat
            class="menubar__button"
            :class="{ 'v-btn--active': isActive.underline() }"
            @click="commands.underline"
          >
            <v-icon>mdi-format-underline</v-icon>
          </v-btn>

          <!-- <v-btn small flat class="menubar__button" :class="{ 'v-btn--active': isActive.code() }" @click="commands.code">
                                <v-icon>code</v-icon>
                            </v-btn> -->

          <v-btn
            small
            flat
            class="menubar__button"
            :class="{ 'v-btn--active': isActive.paragraph() }"
            @click="commands.paragraph"
          >
            <v-icon>mdi-format-paragraph</v-icon>
          </v-btn>

          <v-btn
            small
            flat
            class="menubar__button"
            :class="{ 'v-btn--active': isActive.heading({ level: 1 }) }"
            @click="commands.heading({ level: 1 })"
          >
            H1
          </v-btn>

          <v-btn
            small
            flat
            class="menubar__button"
            :class="{ 'v-btn--active': isActive.heading({ level: 2 }) }"
            @click="commands.heading({ level: 2 })"
          >
            H2
          </v-btn>

          <v-btn
            small
            flat
            class="menubar__button"
            :class="{ 'v-btn--active': isActive.heading({ level: 3 }) }"
            @click="commands.heading({ level: 3 })"
          >
            H3
          </v-btn>

          <v-btn
            small
            flat
            class="menubar__button"
            :class="{ 'v-btn--active': isActive.bullet_list() }"
            @click="commands.bullet_list"
          >
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-btn>

          <v-btn
            small
            flat
            class="menubar__button"
            :class="{ 'v-btn--active': isActive.ordered_list() }"
            @click="commands.ordered_list"
          >
            <v-icon>mdi-format-list-numbered</v-icon>
          </v-btn>

          <v-btn
            small
            flat
            class="menubar__button"
            :class="{ 'v-btn--active': isActive.blockquote() }"
            @click="commands.blockquote"
          >
            <v-icon>mdi-format-quote-open</v-icon>
          </v-btn>

          <!-- <v-btn small flat class="menubar__button" :class="{ 'v-btn--active': isActive.code_block() }"
                                @click="commands.code_block">
                                <v-icon>code</v-icon>
                            </v-btn> -->

          <v-btn small flat class="menubar__button" @click="commands.horizontal_rule">
            <v-icon>mdi-minus</v-icon>
          </v-btn>

          <v-btn small flat class="menubar__button" @click="commands.undo">
            <v-icon>mdi-undo</v-icon>
          </v-btn>

          <v-btn small flat class="menubar__button" @click="commands.redo">
            <v-icon>mdi-redo</v-icon>
          </v-btn>
          <!-- <v-btn  small flat class="menubar__button" @click="showImagePrompt(commands.image)">
                                <v-icon>mdi-image-outline</v-icon> 
                            </v-btn> -->
        </div>
      </editor-menu-bar>

      <div hover class="aru-wysiwyg-editor-content ma-0 pa-0 scroll-y" :style="editorStyle">
        <editor-content :editor="editor" />
      </div>
    </v-card>
  </v-card>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  // Image,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions';
export default {
  components: {
    // OgUploadDocument,
    EditorContent,
    EditorMenuBar,
  },
  props: {
    value: {
      type: String,
    },
    maxHeight: {
      type: String,
      default: '200px',
    },
    minHeight: {
      type: String,
      default: '50px',
    },
  },
  data() {
    return {
      text: '',
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          // new Image(),

          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
        ],
        content: this.value,
        onUpdate: ({ getJSON, getHTML }) => {
          // this.json = getJSON()
          this.text = getHTML();
          this.$emit('input', this.text);
        },
      }),
      editorOptions: 0,
    };
  },
  computed: {
    editorStyle() {
      return {
        'max-height': this.maxHeight,
        'min-height': this.minHeight,
        '--prosemirror-min-height': this.minHeight,
      };
    },
  },
  methods: {
    showImagePrompt(command) {
      const src = prompt('Enter the url of your image here');
      if (src !== null) {
        command({ src });
      }
    },
  },
  watch: {
    value: function(val, oldVal) {
      if (!val) {
        this.editor.clearContent();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.aru-wysiwyg-menubar {
  margin-bottom: 1rem;
  transition: visibility 0.2s 0.4s, opacity 0.2s 0.4s;

  &.is-hidden {
    visibility: hidden;
    opacity: 0;
  }

  &.is-focused {
    visibility: visible;
    opacity: 1;
    transition: visibility 0.2s, opacity 0.2s;
  }

  .menubar__button {
    min-width: 20px;
    margin-left: 0;
  }
}
</style>

<style lang="scss">
:root {
  --prosemirror-min-height: 50px;
}

.aru-wysiwyg-editor-content {
  .ProseMirror {
    min-height: var(--prosemirror-min-height);
    cursor: text;
    padding: 0 1rem 1rem 1rem;
    &:focus {
      // background-color: #f5f5f5;
      // border: solid 1px silver;
      -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
      outline-style: none;
    }
  }
}
</style>
